import { render, staticRenderFns } from "./payer-data-input.component.vue?vue&type=template&id=3e56c18b"
import script from "./payer-data-input.component.vue?vue&type=script&lang=js"
export * from "./payer-data-input.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports